"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionFilterType = exports.ChannelType = exports.EOperationStatus = exports.EOperationDirect = exports.EOperationType = exports.ITicketStatus = exports.ETypeBet = void 0;
var ETypeBet;
(function (ETypeBet) {
    ETypeBet[ETypeBet["Ordinar"] = 1] = "Ordinar";
    ETypeBet[ETypeBet["Express"] = 2] = "Express";
    ETypeBet[ETypeBet["System"] = 3] = "System";
    ETypeBet[ETypeBet["BetBuilder"] = 4] = "BetBuilder";
    ETypeBet[ETypeBet["Tinder"] = 5] = "Tinder";
})(ETypeBet || (exports.ETypeBet = ETypeBet = {}));
var ITicketStatus;
(function (ITicketStatus) {
    ITicketStatus[ITicketStatus["Unsettled"] = 0] = "Unsettled";
    ITicketStatus[ITicketStatus["Settled"] = 1] = "Settled";
})(ITicketStatus || (exports.ITicketStatus = ITicketStatus = {}));
var EOperationType;
(function (EOperationType) {
    EOperationType[EOperationType["RealCash"] = 0] = "RealCash";
    EOperationType[EOperationType["BonusCash"] = 1] = "BonusCash";
    EOperationType[EOperationType["Unit"] = 2] = "Unit";
})(EOperationType || (exports.EOperationType = EOperationType = {}));
var EOperationDirect;
(function (EOperationDirect) {
    EOperationDirect[EOperationDirect["Deposit"] = 1] = "Deposit";
    EOperationDirect[EOperationDirect["Withdraw"] = 2] = "Withdraw";
})(EOperationDirect || (exports.EOperationDirect = EOperationDirect = {}));
var EOperationStatus;
(function (EOperationStatus) {
    EOperationStatus[EOperationStatus["Created"] = 0] = "Created";
    EOperationStatus[EOperationStatus["Verified"] = 1] = "Verified";
    EOperationStatus[EOperationStatus["InvalidOperation"] = 2] = "InvalidOperation";
    EOperationStatus[EOperationStatus["Canceled"] = 3] = "Canceled";
    EOperationStatus[EOperationStatus["WaitActivation"] = 4] = "WaitActivation";
    EOperationStatus[EOperationStatus["InProcessActivation"] = 5] = "InProcessActivation";
    EOperationStatus[EOperationStatus["InProcessActivationDisabled"] = 6] = "InProcessActivationDisabled";
    EOperationStatus[EOperationStatus["RollingSpins"] = 7] = "RollingSpins";
    EOperationStatus[EOperationStatus["RollingTime"] = 8] = "RollingTime";
})(EOperationStatus || (exports.EOperationStatus = EOperationStatus = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType[ChannelType["TournamentPayoutCash"] = 44] = "TournamentPayoutCash";
    ChannelType[ChannelType["TournamentPayoutBonus"] = 45] = "TournamentPayoutBonus";
    ChannelType[ChannelType["CashBonusExpiration"] = 46] = "CashBonusExpiration";
    ChannelType[ChannelType["BonusCancellation"] = 47] = "BonusCancellation";
    ChannelType[ChannelType["CashPromoAccural"] = 48] = "CashPromoAccural";
    ChannelType[ChannelType["BonusPromoAccural"] = 49] = "BonusPromoAccural";
    ChannelType[ChannelType["CasinoBonusDeposit"] = 50] = "CasinoBonusDeposit";
    ChannelType[ChannelType["CasinoBonusFreespin"] = 51] = "CasinoBonusFreespin";
    ChannelType[ChannelType["BonusDeposit"] = 52] = "BonusDeposit";
    ChannelType[ChannelType["Units"] = 53] = "Units";
    ChannelType[ChannelType["BonusRegistration"] = 54] = "BonusRegistration";
    ChannelType[ChannelType["WeekCashback"] = 55] = "WeekCashback";
    ChannelType[ChannelType["NewLoyaltyLevel"] = 56] = "NewLoyaltyLevel";
    ChannelType[ChannelType["VipClubLevel"] = 57] = "VipClubLevel";
    ChannelType[ChannelType["RakeBack"] = 58] = "RakeBack";
    ChannelType[ChannelType["Monthly"] = 59] = "Monthly";
    ChannelType[ChannelType["Weekly"] = 60] = "Weekly";
    ChannelType[ChannelType["Egt"] = 61] = "Egt";
    ChannelType[ChannelType["Referral"] = 85] = "Referral";
})(ChannelType || (exports.ChannelType = ChannelType = {}));
var TransactionFilterType;
(function (TransactionFilterType) {
    TransactionFilterType[TransactionFilterType["Deposit"] = 0] = "Deposit";
    TransactionFilterType[TransactionFilterType["Withdraw"] = 1] = "Withdraw";
    TransactionFilterType[TransactionFilterType["CasinoBets"] = 2] = "CasinoBets";
    TransactionFilterType[TransactionFilterType["RakeBackHistory"] = 3] = "RakeBackHistory";
    TransactionFilterType[TransactionFilterType["NewVipLevelHistory"] = 4] = "NewVipLevelHistory";
    TransactionFilterType[TransactionFilterType["EgtHistory"] = 5] = "EgtHistory";
    TransactionFilterType[TransactionFilterType["MonthlyHistory"] = 6] = "MonthlyHistory";
    TransactionFilterType[TransactionFilterType["WeeklyHistory"] = 7] = "WeeklyHistory";
    TransactionFilterType[TransactionFilterType["TournamentPrizeHistory"] = 8] = "TournamentPrizeHistory";
    TransactionFilterType[TransactionFilterType["Bonuses"] = 9] = "Bonuses";
    TransactionFilterType[TransactionFilterType["BonusPromoAccural"] = 10] = "BonusPromoAccural";
    TransactionFilterType[TransactionFilterType["ActiveTournament"] = 11] = "ActiveTournament";
    TransactionFilterType[TransactionFilterType["ActiveWeekly"] = 12] = "ActiveWeekly";
    TransactionFilterType[TransactionFilterType["ActiveMonthly"] = 13] = "ActiveMonthly";
    TransactionFilterType[TransactionFilterType["ActiveRakeBack"] = 14] = "ActiveRakeBack";
    TransactionFilterType[TransactionFilterType["Referral"] = 15] = "Referral";
    TransactionFilterType[TransactionFilterType["SupportBonus"] = 16] = "SupportBonus";
})(TransactionFilterType || (exports.TransactionFilterType = TransactionFilterType = {}));
